"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Text_style_1 = require("./Text.style");
function Text({ style = [], children, ...props }) {
    // @ts-ignore
    if (react_native_1.Text.defaultProps == null)
        react_native_1.Text.defaultProps = {};
    // @ts-ignore
    react_native_1.Text.defaultProps.allowFontScaling = false;
    return (react_1.default.createElement(react_native_1.Text, { style: [...[Text_style_1.styles.text], ...style], ...props }, children));
}
exports.Text = Text;
